import React, { useState, useEffect } from "react";
import AUTH_API from "api/auth";
import HELPERS from "utils/helper";

const useNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [hasUnread, setHasUnread] = useState(false);
  const userId = HELPERS.getUserId();
  
  const dummyData = { "data": [
    {
      "message": "Your Coach just released a new step <strong>Interview Responses</strong> for you.", 
      "step": "BP",
      "read": false,
      "dateTime": "2025-01-25 10:30:00",
      "title": "New Product Arrival",
      "type": "NR"
    },
    {
      "message": "There is activity on your <strong>Group Discussion Board</strong>.", 
      "step": "TR",
      "read": false,
      "dateTime": "2025-02-25 10:30",
      "title": "New Product Arrival",
      "type": "STG"
    },
    {
      "message": "Your meeting with <strong>Your Coach</strong> is coming up! Have you prepared for your meeting?", 
      "step": "TI",
      "read": false,
      "dateTime": "2025-03-25 10:30",
      "title": "New Product Arrival",
      "type": "UM"
    },
    {
      "message": "Your Coach reviewed your <strong>Resume</strong> and left feedback for you to check.", 
      "step": "RE",
      "read": false,
      "dateTime": "2025-05-14 12:24",
      "title": "New Product Arrival",
      "type": "MT"
    },
    {
      "message": "<strong>Interview with Google</strong> is coming up. Have you prepared?", 
      "step": "RR",
      "read": false,
      "dateTime": "2025-05-14 10:30",
      "title": "New Product Arrival",
      "type": "UM"
    },
    {
      "message": "Your Coach just released a new step <strong>Interview Responses</strong> for you.", 
      "step": "BP",
      "read": false,
      "dateTime": "2025-01-25 10:30",
      "title": "New Product Arrival",
      "type": "NR"
    },
    {
      "message": "There is activity on your <strong>Group Discussion Board</strong>.", 
      "step": "TR",
      "read": false,
      "dateTime": "2025-02-25 10:30",
      "title": "New Product Arrival",
      "type": "UM"
    },
    {
      "message": "Your meeting with <strong>Your Coach</strong> is coming up! Have you prepared for your meeting?", 
      "step": "TI",
      "read": false,
      "dateTime": "2025-05-12 12:45",
      "title": "New Product Arrival",
      "type": "STG"
    },
    {
      "message": "Your Coach reviewed your <strong>Resume</strong> and left feedback for you to check.", 
      "step": "RE",
      "read": false,
      "dateTime": "2025-05-14 09:30",
      "title": "New Product Arrival",
      "type": "MT"
    },
    {
      "message": "<strong>Interview with Google</strong> is coming up. Have you prepared?", 
      "step": "RR",
      "read": false,
      "dateTime": "2025-05-25 09:30",
      "title": "New Product Arrival",
      "type": "UM"
    },
  ] }

  // Function to assign an icon based on type
  const getIcon = (type) => {  
    switch (type) {
      case "NR":
        return "https://django-woken-static.s3.amazonaws.com/static/media/notification_notify1.svg";
      case "GOAL":
        return "https://django-woken-static.s3.amazonaws.com/static/media/notification_notify2.svg";
      case "MEET":
        return "https://django-woken-static.s3.amazonaws.com/static/media/notification_notify3.svg";
      default:
        return "https://django-woken-static.s3.amazonaws.com/static/media/notification_notify4.svg";
    }
  };

  // Process notifications from API response
  const formatNotifications = (apiData) => {
    console.log('sss notification api data', apiData)
    return apiData
      .sort((a, b) => a.read - b.read) // Unread first, then read
      // .slice(0,5)
      .map((item) => ({
        id: item.id,
        icon: getIcon(item.type),
        // message: highlightText(item.message, item.title),
        message: item.message,
        time: formatTime(item.dateTime),
        dateTime: item.dateTime,
        read: item.read, // Keep the original read/unread status
        type: item.type, // Keep the original read/unread status
        // step: item.step,
      }));
  };

  const formatTime = (date_time) => {
    const now = new Date();
    const time = new Date(date_time);
    const diffInSeconds = Math.floor((now - time) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} ${(Math.floor(diffInSeconds / 60)) <= 1 ? 'minute' : 'minutes'} ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} ${(Math.floor(diffInSeconds / 3600)) <= 1 ? "hour" : "hours"} ago`;
    return `${Math.floor(diffInSeconds / 86400)} ${(Math.floor(diffInSeconds / 86400)) <= 1 ? "day" : "days"} ago`;
  };

  // Function to highlight title inside the message
  const highlightText = (message, title) => {
    if (!message) return title; // If message is empty, show title

    const regex = new RegExp(`(${title})`, "gi");
    return message.split(regex).map((part, index) =>
      part.toLowerCase() === title.toLowerCase() ? <strong key={index}>{part}</strong> : part
    );
  };

  // Fetch notifications from API
  const fetchNotifications = async () => {
    try {
      // const data = dummyData.data.sort((a, b) => {
      //   return new Date(a.dateTime) - new Date(b.dateTime);
      // }).reverse();

      // const formattedData = formatNotifications(data); // Store processed notifications
      // console.log('sss formattedData', formattedData, formattedData.some((notif) => !notif.read))

      // setNotifications(formattedData);
      // setHasUnread(formattedData.some((notif) => !notif.read));

      AUTH_API.getNotification(userId)
        .then((response) => {
          console.log("sss response", response);
          const formattedData = formatNotifications(response.data)
          console.log('sss formattedData', formattedData)
          setNotifications(formattedData);
          setHasUnread(formattedData.some((notif) => !notif.read));
        })
        .catch((err) => {
          console.log("get api error", err);
        });

    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  // Fetch notifications every 10 seconds
  useEffect(() => {
    fetchNotifications();
    // const interval = setInterval(fetchNotifications, 10000);
    // return () => clearInterval(interval);
  }, []);

  // Mark notifications as read
  const markAsRead = async () => {
    try {
      console.log('sss notifications 1', notifications)
      setNotifications((prev) =>
        // prev.map(({ icon, time, ...rest }) => ({
        //   ...rest,
        //   read: true,
        // }))
        prev.map((notif) => ({ ...notif, read: true }))
      );
      setHasUnread(false)
      notifications.map((noti) => {

        AUTH_API.patchNotification(userId, noti.id, true)
          .then((response) => {
            console.error("sss response patchNotification", response);
            // const formattedData = formatNotifications(response.data)
            // setNotifications(formattedData);
            // setHasUnread(formattedData.some((notif) => !notif.read));
          })
          .catch((err) => {
            console.log("get api error patchNotification", err);
          });
      })
      
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }
  };


  return { notifications, hasUnread, markAsRead };
};

export default useNotifications;
